<script setup lang="ts">
import MenuList from '@app/layout/nav/mobile/components/MenuList.vue';
import Divider from '@components/Divider.vue';
import SubmenuItem from '@app/layout/nav/SubmenuItem.vue';
import { trans } from '@tools/translation.ts';
import { computed } from 'vue';
import Typography from '@components/Typography.vue';
import Icon from '@components/Icon.vue';
import { IconPhoneCall, IconPhoneInbound, IconEnvelope, IconQuestionCircle } from '@icons';
import { storeToRefs } from 'pinia';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import { URL_CONTACT } from '@tools/routes/routes';

const {
  calendlyUrl,
  faqLink,
  salesPhone,
  internationalSalesPhone,
} = storeToRefs(useNavbarStore());

const companyName = computed<string>(() => window.COMPANY_NAME);
</script>

<template>
  <MenuList class="space-y-2">
    <li>
      <SubmenuItem
        :link="`tel:${internationalSalesPhone}`"
        class="!h-12"
      >
        <div class="desktop-help-menu__submenu-item">
          <Icon
            :svg="IconPhoneCall"
            width="24"
            height="24"
            fill="gray-darker"
          />

          <div class="flex items-center space-x-1">
            <Typography variant="body">
              {{ trans('user_menu.call_company', { company_name: companyName }) }}
            </Typography>

            <Typography variant="body-bold">
              • {{ salesPhone }}
            </Typography>
          </div>
        </div>
      </SubmenuItem>
    </li>

    <li>
      <SubmenuItem
        :link="calendlyUrl ?? undefined"
        class="!h-12"
      >
        <div class="desktop-help-menu__submenu-item">
          <Icon
            :svg="IconPhoneInbound"
            width="24"
            height="24"
            stroke="gray-darker"
          />

          <Typography variant="body">
            {{ trans('user_menu.recalled') }}
          </Typography>
        </div>
      </SubmenuItem>
    </li>

    <li>
      <SubmenuItem
        :link="URL_CONTACT"
        class="!h-12"
      >
        <div class="desktop-help-menu__submenu-item">
          <Icon
            :svg="IconEnvelope"
            width="24"
            height="24"
            fill="gray-darker"
          />

          <Typography variant="body">
            {{ trans('user_menu.send_message') }}
          </Typography>
        </div>
      </SubmenuItem>
    </li>

    <li class="px-3">
      <Divider class="my-4" color="gray" />
    </li>

    <li>
      <SubmenuItem
        :link="faqLink ?? undefined"
        class="!h-12"
      >
        <div class="desktop-help-menu__submenu-item">
          <Icon
            :svg="IconQuestionCircle"
            width="24"
            height="24"
            fill="gray-darker"
          />

          <Typography variant="body">
            {{ trans('user_menu.faq') }}
          </Typography>
        </div>
      </SubmenuItem>
    </li>
  </MenuList>
</template>

<style scoped lang="scss">
.desktop-help-menu {
  &__submenu-item {
    @apply flex items-center space-x-2;
  }
}
</style>
